export default __webpack_public_path__ + "static/publicis-logo-1d48993497bd31db0f22ea0bbd45cf7e.png";